module.exports = __webpack_public_path__ + "static/media/UK-Leeds.e109f976.png";